import { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';

// Function to determine limit based on screen size
const getResponsiveLimit = () => {
  const windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
  if (windowWidth > 1919) return 16; // > 1920px
  if (windowWidth > 1535) return 12; // 1536px - 1920px
  if (windowWidth > 1199) return 10; // 1200px - 1535px
  if (windowWidth > 899) return 8;   // 900px - 1199px
  return 4;
};

// Custom hook for handling dynamic limit based on screen size
export const useResponsiveLimitProduct = () => {
  // Set the default initial limit dynamically
  const [limitMore, setLimitMore] = useState(() => getResponsiveLimit());
  const [offset, setOffset] = useState(0);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    let resizeTimeout: NodeJS.Timeout;

    const updateLimit = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => setLimitMore(getResponsiveLimit()), 300);
    };

    window.addEventListener('resize', updateLimit);

    return () => {
      clearTimeout(resizeTimeout);
      window.removeEventListener('resize', updateLimit);
    };
  }, []);

  // Increment offset by the limit amount
  const incrementOffset = () => {
    setOffset((prevOffset) => prevOffset + limitMore);
  };

  const resetOffset = () => {
    setOffset(limitMore); // Reset the offset to the current limit
  };

  return { limitMore, offset, incrementOffset, resetOffset, loadingMore, setLoadingMore };
};
